import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import * as moment from "moment";

@Component({
  selector: "app-admin-management",
  templateUrl: "./admin-management.component.html",
  styleUrls: ["./admin-management.component.scss"],
})
export class AdminManagementComponent implements OnInit {
  datalistDisplayedColumns: string[] = [
    "Date",
    "transaction_id",
    "from_to",
    "points",
    "amount",
    "my_share",
    "status",
  ];

  selected: any = { startDate: 0, endDate: 0 };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  datalist = new MatTableDataSource<any>();
  selectedUserName = "";
  filterUsers = [];
  users = [];
  status: "";
  reportsData = [];
  constructor(private appService: AppService) {}

  ngOnInit() {
    this.getUsersList();
    this.getReportData();
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  getUsersList() {
    try {
      this.appService.getUsersList().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.users = res.users;
          this.filterUsers = res.users;
        }
      });
    } catch (err) {}
  }
  getBetPlaceDate(date: number) {
    return moment(date).format("DD MMM YYYY hh:mm A");
  }

  onUserSearchHandler(key: string) {
    this.filterUsers = this.users.filter((user) =>
      user.userName.toLowerCase().startsWith(key)
    );
    this.selected.startDate = 0;
    this.selected.end_time = 0;
    if (!key) {
      this.getReportData();
    }
  }
  onChangeUserSelection(event: any) {
    const selectedUser = this.filterUsers.filter((user) => {
      return user.userName === event.option.value;
    });
    if (selectedUser) {
      this.selectedUserName = selectedUser[0].userName;
      this.getReportData();
    }
  }
  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };
  downloadReports() {
    // let data = this.reportsData;
    // const url = window.URL.createObjectURL(new Blob(data));
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", "statment.xls");
    // document.body.appendChild(link);
    // link.click();
  }

  onChangeStatus(status) {
    this.status = status;
    let filterData = this.reportsData.filter((item) => item.status === status);
    this.datalist = new MatTableDataSource<any>(filterData);
    this.datalist.paginator = this.paginator;
  }
  RefreshData() {
    this.status = "";
    this.getReportData();
  }
  getReportData = () => {
    try {
      let filters = {
        user_name: this.selectedUserName ? this.selectedUserName : null,
        start_time:
          this.selected.startDate !== null
            ? new Date(this.selected.startDate).getTime() / 1000
            : //moment(this.selected.startDate).valueOf()
              0,
        end_time:
          this.selected.endDate !== null
            ? new Date(this.selected.endDate).getTime() / 1000
            : //moment(this.selected.endDate).valueOf()
              0,
      };
      this.appService.getAdminStatmentData(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.reportsData = res.myAccStatement;
          this.datalist = new MatTableDataSource<any>(res.myAccStatement);
          this.datalist.paginator = this.paginator;
        }
      });
    } catch (err) {}
  };
}
